import { useState, useEffect } from "react";

export function useIsMobile(breakpoint = 992) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.matchMedia(`(max-width: ${breakpoint}px)`).matches
      : false
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const query = `(max-width: ${breakpoint}px)`;
    const mediaQuery = window.matchMedia(query);

    setIsMobile(mediaQuery.matches);

    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
}
